/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { override } from 'flarum/common/extend';
import ArticleBookshelfDropdown from '../components/ArticleBookshelfDropdown';
import ArticleBookshelfDropdownModal from 'flarum/orell-articles/components/ArticleBookshelfDropdownModal';
import ArticleNoteModal from 'flarum/orell-articles/components/ArticleNoteModal';

export default function (): void {
	override(ArticleBookshelfDropdownModal.prototype, 'dropdownView', function () {
		return <ArticleBookshelfDropdown article={this.article} onClose={() => this.hide()} />;
	});

	override(ArticleNoteModal.prototype, 'dropdownView', function () {
		return <ArticleBookshelfDropdown article={this.article} onClose={() => this.hide()} />;
	});
}
